// extracted by mini-css-extract-plugin
export default {"wrapper":"EditEnergyAssetsSettlementRules_wrapper__GxXVk","col":"EditEnergyAssetsSettlementRules_col__bCnDr"};